import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useReviewPendingChanges(onSuccess?: () => void) {
  return useMutation({
    ...orpc.accountsReceivable.salesOrderDrafts.reviewPendingChanges.mutationOptions(),
    onSuccess: onSuccess ? () => onSuccess() : undefined,
  });
}

export default useReviewPendingChanges;
